import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.align || "stretch"};
  justify-content: ${(props) => props.justify || "flex-start"};
  gap: ${(props) => props.gap || "0"};
`;

/**
 * Stack component for vertical (column) layout
 * @param {string} gap - Space between items (e.g., "16px", "1rem")
 * @param {string} align - Cross-axis alignment: "flex-start" | "center" | "flex-end" | "stretch"
 * @param {string} justify - Main-axis alignment: "flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly"
 * @param {string} as - HTML tag to render as (default: "div")
 * @param {React.ReactNode} children - Child elements
 */
function Stack({ children, gap, align, justify, as = "div", ...props }) {
  return (
    <Wrapper
      as={as}
      gap={gap}
      align={align}
      justify={justify}
      {...props}
    >
      {children}
    </Wrapper>
  );
}

export default Stack;